import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import {
  Panel,
  Message,
  Grid,
  Row,
  Col,
  Input,
  Slider,
  SelectPicker,
  ControlLabel,
  Button,
  CheckboxGroup,
  Checkbox,
  Uploader,
  Icon,
  RadioGroup,
  Radio,
} from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import './styles.less'
import CKEditorBlankFrom from '../../components/forms/input/CKEditorBlankFrom'
import InputForm from '../../components/forms/input/InputForm'
import { isRequired, isValidators } from '../../utils/ValidatorUtils'
import classNames from 'classnames'
import { cloneDeep } from 'lodash-es'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import AppContext from '../../context/AppContext'
import IncomeRecordFileTable from '../incomeRecordWidget/IncomeRecordFileTable'
import { v4 as uuidv4 } from 'uuid'
import ConduciveHealthWidget from './ConduciveHealthWidget'
import BeneficiaryWidget from './BeneficiaryWidget'
import HealthInnovationWidget from './HealthInnovationWidget'
import BestPracticeWidgets from './BestPracticeWidgets.js'
import { doneLoading, startLoading } from '../../utils/loading.js'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText.js'
import notification from '../../utils/notification.js'
import {
  getProgressReportSubprojectClose,
  saveLeaders,
} from '../../redux/actions/progressReportSubproject.js'
import { useDispatch } from 'react-redux'
import { getSchemaSubProjectDep6Sidebar } from '../../redux/actions/sidebar.js'

export default function OutcomesWidget({
  schema: _schema,
  isRole,
  isReadOnly,
  period,
  projectCode,
  projectVersionId,
  progressActivityId,
  setProgressReportsId = () => {},
  installmentPlanId,
  disabled,
  ...props
}) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { theme } = React.useContext(AppContext)
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, getValues, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [progressValue, setProgressValue] = useState([])
  const [deleteId, setDeleteId] = useState([])
  const [mapValues, setMapValues] = useState(new Map())
  const projectId = sessionStorage.getItem('projectId')
  const dispatch = useDispatch()

  useEffect(() => {
    setFormSchema(_schema)

    // console.log('_schema?.values => ', progressValue?.values)

    setProgressValue(_schema?.values || null)
    setDataToMap(_schema?.values)
  }, [_schema])

  const setDataToMap = (value) => {
    var objMap = new Map()
    value?.forEach((e) => {
      objMap.set(e.id, e)
    })
    setMapValues(objMap)
  }

  const handleAdd = () => {
    let progressVal = cloneDeep(progressValue)
    let mapVal = cloneDeep(mapValues)
    let data = {
      id: 'addNew-' + uuidv4(),
      title: progressValue[0].title,
      leadersName: '',
      responsible: '',
      contactMobile: '',
      contactEmail: '',
    }
    progressVal.push(data)
    mapVal.set(data.id, data)
    setMapValues(mapVal)
    setProgressValue(progressVal)
  }

  const handleDelete = (item, index) => {
    let progressVal = cloneDeep(progressValue)
    let mapVal = cloneDeep(mapValues)
    if (index > -1) {
      progressVal.splice(index, 1)
    }
    if (!item.id.startsWith('addNew-')) {
      setDeleteId([...deleteId, item.id])
    }
    mapVal.delete(item.id)
    setMapValues(mapVal)
    setProgressValue(progressVal)
  }

  const onSubmitInfoOutcomes = (data) => {
    let combinedData = []
    progressValue?.forEach((i) => {
      let mapval = mapValues.get(i.id)
      combinedData.push({
        id: mapval.id === null ? '' : mapval.id.indexOf('addNew-') == -1 ? mapval.id : '',
        leadersName: mapval.name,
        responsible: mapval.role,
        contactMobile: mapval.telephone,
        contactEmail: mapval.email,
      })
    })

    const request = {
      projectVersionId: projectVersionId || '',
      projectCode: projectCode || '',
      period: period || '',
      installmentPlanDetailId: installmentPlanId,
      leadersLists: combinedData,
      deleteLeaderIds: deleteId || [],
    }

    handleCallService(request)
  }
  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError()

    try {
      const response = await saveLeaders(request)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        setProgressReportsId(response.progressReportsId)
        handleGetSchema()
        await dispatch(getSchemaSubProjectDep6Sidebar(projectId))
      } else {
        setErrorMsg({ type: 'error', description: response.errorMessage })
      }
    } catch (error) {
      console.error('try catch error ', error)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }
  const handleGetSchema = async () => {
    startLoading()
    try {
      const response = await getProgressReportSubprojectClose(
        period,
        projectCode,
        projectVersionId,
        installmentPlanId
      )

      if (response) {
        setFormSchema(response?.forms?.otherOutcomes)
        setProgressValue(response?.forms?.otherOutcomes?.values || null)
        setDataToMap(response?.forms?.otherOutcomes?.values)
      }
    } catch (e) {
      console.log(' error', e)
    }
    doneLoading()
  }

  return (
    <>
      <Panel header={formSchema.header} shaded collapsible defaultExpanded>
        <Row style={{ marginTop: -20 }}>
          <Col lg={24} md={24} sm={24} xs={24}>
            <div style={{ paddingLeft: 20, paddingRight: 25 }}>
              <div>
                <h6>{formSchema.subTitle}</h6>
              </div>
            </div>
          </Col>
        </Row>

        {progressValue &&
          progressValue.map((item, index) => {
            return (
              <>
                <Row style={{ marginTop: 10 }}>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <div style={{ paddingLeft: 30, paddingRight: 25 }}>
                      <h6>{`${index + 1}. ${item?.title}`}</h6>
                    </div>
                  </Col>
                </Row>

                <div style={{ paddingLeft: 50, paddingRight: 20 }}>
                  <Row style={{ marginTop: 10 }}>
                    <Col lg={11} md={11} sm={11} xs={11}>
                      {!disabled ? (
                        <>
                          <ControlLabel
                            className={classNames(
                              isRequired(formSchema.fullNameInput.validators) && 'required'
                            )}
                          >
                            {formSchema.fullNameInput.label}
                          </ControlLabel>

                          <InputForm
                            schema={formSchema.fullNameInput}
                            // value={item.name}
                            name={`${formSchema.fullNameInput.name}_${item.id}`}
                            placeholder={'ระบุ' + formSchema.fullNameInput.label}
                            register={register}
                            Controller={Controller}
                            control={control}
                            errors={errors}
                            setValue={setValue}
                            clearErrors={clearErrors}
                            hideLabel={true}
                            value={mapValues?.get(item.id)?.name}
                            onChange={(value) => {
                              let nObj = cloneDeep(mapValues)
                              nObj.get(item.id).name = value
                              setMapValues(nObj)
                            }}
                          />
                        </>
                      ) : (
                        <>
                          <b> {formSchema.fullNameInput.label}</b>
                          <p>{mapValues?.get(item.id)?.name}</p>
                        </>
                      )}
                    </Col>
                    <Col lg={11} md={11} sm={11} xs={11}>
                      {!disabled ? (
                        <>
                          <ControlLabel
                            className={classNames(
                              isRequired(formSchema.roleInput.validators) && 'required'
                            )}
                          >
                            {formSchema.roleInput.label}
                          </ControlLabel>

                          <InputForm
                            schema={formSchema.roleInput}
                            name={`${formSchema.roleInput.name}_${item.id}`}
                            placeholder={'ระบุ' + formSchema.roleInput.label}
                            register={register}
                            Controller={Controller}
                            control={control}
                            errors={errors}
                            setValue={setValue}
                            clearErrors={clearErrors}
                            hideLabel={true}
                            value={mapValues?.get(item.id)?.role}
                            onChange={(value) => {
                              let nObj = cloneDeep(mapValues)
                              nObj.get(item.id).role = value
                              setMapValues(nObj)
                            }}
                          />
                        </>
                      ) : (
                        <>
                          <b> {formSchema.roleInput.label}</b>
                          <p>{mapValues?.get(item.id)?.role}</p>
                        </>
                      )}
                    </Col>
                    <Col lg={2} md={2} sm={2} xs={2}></Col>
                  </Row>

                  <Row style={{ marginTop: 10 }}>
                    <Col lg={11} md={11} sm={11} xs={11}>
                      {!disabled ? (
                        <>
                          <ControlLabel
                            className={classNames(
                              isRequired(formSchema.telephoneInput.validators) && 'required'
                            )}
                          >
                            {formSchema.telephoneInput.label}
                          </ControlLabel>
                          <InputForm
                            schema={formSchema.telephoneInput}
                            name={`${formSchema.telephoneInput.name}_${item.id}`}
                            placeholder={'ระบุ' + formSchema.telephoneInput.label}
                            register={register}
                            Controller={Controller}
                            control={control}
                            errors={errors}
                            setValue={setValue}
                            clearErrors={clearErrors}
                            hideLabel={true}
                            value={mapValues?.get(item.id)?.telephone}
                            onChange={(value) => {
                              let nObj = cloneDeep(mapValues)
                              nObj.get(item.id).telephone = value
                              setMapValues(nObj)
                            }}
                            isInputNumber={true}
                          />
                        </>
                      ) : (
                        <>
                          <b> {formSchema.telephoneInput.label}</b>
                          <p>{mapValues?.get(item.id)?.telephone}</p>
                        </>
                      )}
                    </Col>
                    <Col lg={11} md={11} sm={11} xs={11}>
                      {!disabled ? (
                        <>
                          <ControlLabel
                            className={classNames(
                              isRequired(formSchema.email.validators) && 'required'
                            )}
                          >
                            {formSchema.email.label}
                          </ControlLabel>
                          <InputForm
                            schema={formSchema.email}
                            name={`${formSchema.email.name}_${item.id}`}
                            placeholder={'ระบุ' + formSchema.email.label}
                            register={register}
                            Controller={Controller}
                            control={control}
                            errors={errors}
                            setValue={setValue}
                            clearErrors={clearErrors}
                            hideLabel={true}
                            value={mapValues?.get(item.id)?.email}
                            onChange={(value) => {
                              let nObj = cloneDeep(mapValues)
                              nObj.get(item.id).email = value
                              setMapValues(nObj)
                            }}
                          />
                        </>
                      ) : (
                        <>
                          <b> {formSchema.email.label}</b>
                          <p>{mapValues?.get(item.id)?.email}</p>
                        </>
                      )}
                    </Col>
                    {!disabled ? (
                      <Col lg={2} md={2} sm={2} xs={2}>
                        {progressValue.length > 1 && (
                          <div style={{ marginTop: 33 }}>
                            <Button color="red" onClick={() => handleDelete(item, index)}>
                              ลบ
                            </Button>
                          </div>
                        )}

                        {progressValue.length == index + 1 && (
                          <>
                            <div style={{ marginTop: 33 }}>
                              <Button color="blue" onClick={() => handleAdd()}>
                                เพิ่ม
                              </Button>
                            </div>
                          </>
                        )}
                      </Col>
                    ) : (
                      <Col lg={2} md={2} sm={2} xs={2}></Col>
                    )}
                  </Row>
                </div>
              </>
            )
          })}

        {!disabled && progressValue?.length > 0 && (
          <Row style={{ marginTop: 20 }}>
            <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <div style={{ paddingLeft: 40, paddingRight: 25 }}>
                <SaveButton disabled={isLoading} onClick={handleSubmit(onSubmitInfoOutcomes)}>
                  บันทึก
                </SaveButton>
              </div>
            </Col>
          </Row>
        )}

        {/* จำนวนผู้ได้รับผลประโยชน์จากโครงการนี้ */}
        {formSchema.beneficiary && (
          <>
            <BeneficiaryWidget
              schema={formSchema}
              period={period}
              projectCode={projectCode}
              projectVersionId={projectVersionId}
              progressActivityId={progressActivityId}
              setProgressReportsId={setProgressReportsId}
              installmentPlanId={installmentPlanId}
              disabled={disabled}
            />
          </>
        )}

        {/* สภาพแวดล้อมหรือปัจจัยทางสังคมที่เอื้อต่อสุขภาพ */}
        {formSchema.conduciveHealth && (
          <>
            <ConduciveHealthWidget
              schema={formSchema}
              period={period}
              projectCode={projectCode}
              projectVersionId={projectVersionId}
              installmentPlanId={installmentPlanId}
              disabled={disabled}
              progressActivityId={progressActivityId}
              setProgressReportsId={setProgressReportsId}
            />
          </>
        )}

        {/* 3.3 นวัตกรรมสร้างเสริมสุขภาพ */}
        {formSchema.healthInnovation && (
          <>
            <HealthInnovationWidget
              schema={formSchema}
              period={period}
              projectCode={projectCode}
              projectVersionId={projectVersionId}
              installmentPlanId={installmentPlanId}
              disabled={disabled}
              progressActivityId={progressActivityId}
              setProgressReportsId={setProgressReportsId}
            />
          </>
        )}

        {/* โครงการตัวอย่างที่ดี (Best Practice) */}
        {formSchema.bestPractice && (
          <>
            <BestPracticeWidgets
              schema={formSchema}
              period={period}
              projectCode={projectCode}
              projectVersionId={projectVersionId}
              progressActivityId={progressActivityId}
              setProgressReportsId={setProgressReportsId}
              installmentPlanId={installmentPlanId}
              disabled={disabled}
            />
          </>
        )}
      </Panel>

      {/* </Panel> */}
    </>
  )
}
